import React, { Component } from "react"
import { OptionLabelContainer, OptionLabel } from "./styles"
import Translate from "components/Translate/container"

export class OptionalLabel extends Component {
  render() {
    return (
      <OptionLabelContainer>
        <OptionLabel>
          <Translate>Optional</Translate>
        </OptionLabel>
      </OptionLabelContainer>
    )
  }
}

export default OptionalLabel
